module.exports = "<p>\n  share-link works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/share-map/share-link/share-link.component.html
// module id = ./src/app/components/popups/share-map/share-link/share-link.component.html
// module chunks = main